import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';

const PARTNERS = [
  { name: 'Marriott', desc: '8.500+ Hotels', query: 'Marriott', localSvg: 'marriott', domain: 'marriott.com', slug: 'marriott' },
  { name: 'Hilton', desc: '7.400+ Hotels', query: 'Hilton', localSvg: 'hilton', domain: 'hilton.com', slug: 'hilton' },
  { name: 'IHG', desc: 'Holiday Inn, Crowne Plaza', query: 'Holiday Inn', localSvg: 'ihg', domain: 'ihg.com', maxWidth: 100 },
  { name: 'Accor', desc: 'Sofitel, Novotel, ibis', query: 'Accor', localSvg: 'accor', domain: 'group.accor.com' },
  { name: 'Hyatt', desc: 'Premium weltweit', query: 'Hyatt', localSvg: 'hyatt', domain: 'hyatt.com' },
  { name: 'Radisson', desc: '1.600+ Hotels', query: 'Radisson', localSvg: 'radisson', domain: 'radissonhotels.com' },
  { name: 'Wyndham', desc: '9.000+ Hotels', query: 'Wyndham', localSvg: 'wyndham', domain: 'wyndhamhotels.com' },
  { name: 'Best Western', desc: 'Traditionell europäisch', query: 'Best Western', localSvg: 'bestwestern', domain: 'bestwestern.com' },
  { name: 'Kempinski', desc: 'Luxus-Hotels', query: 'Kempinski', localSvg: 'kempinski', domain: 'kempinski.com' },
  { name: 'Four Seasons', desc: 'Ultra-Luxus', query: 'Four Seasons', localSvg: 'fourseasons', domain: 'fourseasons.com' },
  { name: 'Mandarin Oriental', desc: 'Exklusiv', query: 'Mandarin Oriental', localSvg: 'mandarin', domain: 'mandarinoriental.com' },
  { name: 'Ritz-Carlton', desc: '5-Sterne Resorts', query: 'Ritz Carlton', localSvg: 'ritzcarlton', domain: 'ritzcarlton.com', slug: 'ritzcarlton' },
];

export default function HotelPartners({ compact = false, dark = false }) {
  return (
    <section
      className={`${compact ? 'py-14' : 'py-20 sm:py-24'} ${dark ? 'bg-stone-900' : 'bg-white'} border-y ${dark ? 'border-stone-800' : 'border-stone-100'}`}
      data-testid="hotel-partners"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className={`text-xs font-medium uppercase tracking-[0.2em] ${dark ? 'text-stone-500' : 'text-stone-400'} mb-3`}>Hotel-Angebot</p>
          <Link to="/hotel-suche" className="group inline-block">
            <h2 className={`text-2xl sm:text-3xl font-medium tracking-tight ${dark ? 'text-white' : 'text-stone-900'} group-hover:underline underline-offset-4 decoration-stone-300`}>
              Die größten Hotelketten der Welt.
            </h2>
          </Link>
          <p className={`text-sm ${dark ? 'text-stone-400' : 'text-stone-500'} mt-3 max-w-xl mx-auto`}>
            Zugriff auf 1,6 Mio Hotels der größten Marken — Bestpreis für jede FuelX-Buchung.{' '}
            <Link to="/hotel-suche" className="underline hover:text-stone-700">Jetzt buchen →</Link>
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {PARTNERS.map((p, i) => (
            <Link
              key={i}
              to={`/hotel-suche?chain=${encodeURIComponent(p.query)}`}
              className={`${dark ? 'bg-white/95 border-stone-200 hover:bg-white' : 'bg-white border-stone-100 hover:border-stone-300 hover:shadow-lg'} border rounded-2xl p-6 flex flex-col items-center justify-center text-center transition-all group min-h-[150px]`}
              data-testid={`partner-${i}`}
              title={p.name}
              aria-label={p.name}
            >
              <div className="h-16 flex items-center justify-center mb-3 w-full group-hover:scale-110 transition-transform duration-300">
                <BrandLogo name={p.name} localSvg={p.localSvg} slug={p.slug} domain={p.domain} size={64} maxWidth={p.maxWidth} />
              </div>
              <p className="text-[10px] text-stone-400 tracking-wide">{p.desc}</p>
              <p className="text-[10px] mt-2 text-stone-300 group-hover:text-stone-900 transition-colors">Buchen →</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
